// reflect-metadata must be the first import
// organize-imports-ignore
import "reflect-metadata";
import { Container } from "inversify";
import { coreModule } from "@core/core-module.di";
import { authenticationModule } from "@authentication/authentication-module.di";
import { beneficiaryModule } from "@beneficiary/beneficiary-module.di";
import { entityModule } from "@entity/entity-module.di";
import { proceedingModule } from "@proceeding/proceeding-module.di";
import { projectModule } from "@project/project-module.di";
import { userModule } from "@user/user-module.di";
import { postalCodesModule } from "@postal-codes/postal-code-module.di";
import { catalogueModule } from "@catalogue/catalogue-module.di";
import { adminModule } from "@admin/admin-module.di";
import { entityApiKeysModule } from "@entity-api-keys/entity-api-keys-module.di";

const container = Container.merge(
    authenticationModule.module,
    beneficiaryModule.module,
    coreModule.module,
    entityModule.module,
    proceedingModule.module,
    projectModule.module,
    userModule.module,
    postalCodesModule.module,
    catalogueModule.module,
    adminModule.module,
    entityApiKeysModule.module,
);

export { container };
